import _createClass from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _wrapNativeSuper from "/builds/client-projects/fert-demolition-motos-website/application/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
export var ExpiredLogin = /*#__PURE__*/function (_Error) {
  _inherits(ExpiredLogin, _Error);

  var _super = _createSuper(ExpiredLogin);

  function ExpiredLogin(message) {
    _classCallCheck(this, ExpiredLogin);

    return _super.call(this, message);
  }

  return _createClass(ExpiredLogin);
}( /*#__PURE__*/_wrapNativeSuper(Error));